export default "__VITE_ASSET__DnzCLXyV__"